'use strict';

const spanish = [
  {
    charLc: "\xE1",
    charUc: "\xC1",
    macLc: "Option + E, release then type A",
    macUc: "Option + E, release then type Shift + A",
    winLc: "Alt + 0225 or 160",
    winUc: "Alt + 0193"
  },
  {
    charLc: "\xE9",
    charUc: "\xC9",
    macLc: "Option + E, release then type E",
    macUc: "Option + E, release then type Shift + E",
    winLc: "Alt + 0233 or 130",
    winUc: "Alt + 0201 or 144"
  },
  {
    charLc: "\xED",
    charUc: "\xCD",
    macLc: "Option + E, release then type I",
    macUc: "Option + E, release then type Shift + I",
    winLc: "Alt + 0237 or 161",
    winUc: "Alt + 0205"
  },
  {
    charLc: "\xF3",
    charUc: "\xD3",
    macLc: "Option + E, release then type O",
    macUc: "Option + E, release then type Shift + O",
    winLc: "Alt + 0243 or 162",
    winUc: "Alt + 0211"
  },
  {
    charLc: "\xFA",
    charUc: "\xDA",
    macLc: "Option + E, release then type U",
    macUc: "Option + E, release then type Shift + U",
    winLc: "Alt + 0250 or 163",
    winUc: "Alt + 0218"
  },
  {
    charLc: "\xFC",
    charUc: "\xDC",
    macLc: "Option + U, release then type U",
    macUc: "Option + U, release then type Shift + U",
    winLc: "Alt + 0252 or 129",
    winUc: "Alt + 0220 or 154"
  },
  {
    charLc: "\xF1",
    charUc: "\xD1",
    macLc: "Option + N, release then type N",
    macUc: "Option + N, release then type Shift + N",
    winLc: "Alt + 0241 or 164",
    winUc: "Alt + 0209 or 165"
  },
  {
    charLc: "\xA1",
    charUc: "\xA1",
    macLc: "Option + 1",
    macUc: "",
    winLc: "Alt + 0161 or 173",
    winUc: ""
  },
  {
    charLc: "\xBF",
    charUc: "\xBF",
    macLc: "Shift + Option + ?",
    macUc: "",
    winLc: "Alt + 0191 or 168",
    winUc: ""
  },
  {
    charLc: "\xAB",
    charUc: "\xAB",
    macLc: "Option + \\",
    macUc: "",
    winLc: "Alt + 0171 or 174",
    winUc: ""
  },
  {
    charLc: "\xBB",
    charUc: "\xBB",
    macLc: "Shift + Option + \\",
    macUc: "",
    winLc: "Alt + 0187 or 175",
    winUc: ""
  }
];
const german = [
  {
    charLc: "\xE4",
    charUc: "\xC4",
    macLc: "Option + U, release then type A",
    macUc: "Option + U, release then type Shift + A",
    winLc: "Alt + 0228 or 132",
    winUc: "Alt + 0196 or 142"
  },
  {
    charLc: "\xE9",
    charUc: "\xC9",
    macLc: "Option + E, release then type E",
    macUc: "Option + E, release then type SHIFT + E",
    winLc: "ALT + 0233 or 130",
    winUc: "ALT + 0201"
  },
  {
    charLc: "\xF6",
    charUc: "\xD6",
    macLc: "Option + U, release then type O",
    macUc: "Option + U, release then type Shift + O",
    winLc: "Alt + 0246 or 148",
    winUc: "Alt + 0214 or 153"
  },
  {
    charLc: "\xFC",
    charUc: "\xDC",
    macLc: "Option + U, release then type U",
    macUc: "Option + U, release then type Shift + U",
    winLc: "Alt + 0252 or 129",
    winUc: "Alt + 0220"
  },
  {
    charLc: "\xDF",
    charUc: "\xDF",
    macLc: "Option + S",
    macUc: "",
    winLc: "Alt + 0223 or 225",
    winUc: ""
  },
  {
    charLc: "\u201E",
    charUc: "\u201E",
    macLc: "Option + Shift + W",
    macUc: "",
    winLc: "Alt + 0132",
    winUc: ""
  },
  {
    charLc: "\u201C",
    charUc: "\u201C",
    macLc: "Option + [",
    macUc: "",
    winLc: "Alt + 0147",
    winUc: ""
  },
  {
    charLc: "\u20AC",
    charUc: "\u20AC",
    macLc: "Shift + Option + 2",
    macUc: "",
    winUc: "",
    winLc: "Alt + 0128"
  }
];
const french = [
  {
    charLc: "\xE0",
    charUc: "\xC0",
    macLc: "Option + `, release then type A",
    macUc: "Option + `, release then type Shift + A",
    winLc: "Alt + 0224 or 133",
    winUc: "Alt + 0192"
  },
  {
    charLc: "\xE2",
    charUc: "\xC2",
    macLc: "Option + I, release then type A",
    macUc: "Option + I, release then type Shift + A",
    winLc: "Alt + 0226 or 131",
    winUc: "Alt + 0194"
  },
  {
    charLc: "\xE8",
    charUc: "\xC8",
    macLc: "Option + `, release then type E",
    macUc: "Option + `, release then type Shift + E",
    winLc: "Alt + 0232 or 138",
    winUc: "Alt + 0200"
  },
  {
    charLc: "\xE9",
    charUc: "\xC9",
    macLc: "Option + E, release then type E",
    macUc: "Option + E, release then type Shift + E",
    winLc: "Alt + 0233 or 130",
    winUc: "Alt + 0201 or 144"
  },
  {
    charLc: "\xEA",
    charUc: "\xCA",
    macLc: "Option + I, release then type E",
    macUc: "Option + I, release then type Shift + E",
    winLc: "Alt + 0234 or 136",
    winUc: "Alt + 0202"
  },
  {
    charLc: "\xEB",
    charUc: "\xCB",
    macLc: "Option + U, release then type E",
    macUc: "Option + U, release then type Shift + E",
    winLc: "Alt + 0235 or 137",
    winUc: "Alt + 0203"
  },
  {
    charLc: "\xE7",
    charUc: "\xC7",
    macLc: "Option + C",
    macUc: "Option + Shift + C",
    winLc: "Alt + 0231 or 135",
    winUc: "Alt + 0199 or 128"
  },
  {
    charLc: "\xEE",
    charUc: "\xCE",
    macLc: "Option + I, release then type I",
    macUc: "Option + I, release then type Shift + I",
    winLc: "Alt + 0238 or 140",
    winUc: "Alt + 0206"
  },
  {
    charLc: "\xEF",
    charUc: "\xCF",
    macLc: "Option + U, release then type I",
    macUc: "Option + U, release then type Shift + I",
    winLc: "Alt + 0239 or 139",
    winUc: "Alt + 0207"
  },
  {
    charLc: "\xF4",
    charUc: "\xD4",
    macLc: "Option + I, release then type O",
    macUc: "Option + I, release then type Shift + O",
    winLc: "Alt + 0244 or 147",
    winUc: "Alt + 0212"
  },
  {
    charLc: "\u0153",
    charUc: "\u0152",
    macLc: "Option + Q",
    macUc: "Option + Shift + Q",
    winLc: "Alt + 0156",
    winUc: "Alt + 0140"
  },
  {
    charLc: "\xF9",
    charUc: "\xD9",
    macLc: "Option + `, release then type U",
    macUc: "Option + `, release then type Shift + U",
    winLc: "Alt + 0249 or 151",
    winUc: "Alt + 0217"
  },
  {
    charLc: "\xFB",
    charUc: "\xDB",
    macLc: "Option + I, release then type U",
    macUc: "Option + I, release then type Shift + U",
    winLc: "Alt + 0251 or 150",
    winUc: "Alt + 0219"
  },
  {
    charLc: "\xAB",
    charUc: "\xAB",
    macLc: "Option + \\",
    macUc: "",
    winLc: "Alt + 0171 or 174",
    winUc: ""
  },
  {
    charLc: "\xBB",
    charUc: "\xBB",
    macLc: "Shift + Option + \\",
    macUc: "",
    winLc: "Alt + 0187 or 175",
    winUc: ""
  },
  {
    charLc: "\u20AC",
    charUc: "\u20AC",
    macLc: "Shift + Option + 2",
    macUc: "",
    winLc: "Alt + 0128",
    winUc: ""
  }
];
const italian = [
  {
    charLc: "\xE0",
    charUc: "\xC0",
    macLc: "Option + `, release then type A",
    macUc: "Option + `, release then type Shift + A",
    winLc: "Alt + 0224 or 133",
    winUc: "Alt + 0192"
  },
  {
    charLc: "\xE8",
    charUc: "\xC8",
    macLc: "Option + `, release then type E",
    macUc: "Option + `, release then type Shift + E",
    winLc: "Alt + 0232 or 138",
    winUc: "Alt + 0200"
  },
  {
    charLc: "\xE9",
    charUc: "\xC9",
    macLc: "Option + E, release then type E",
    macUc: "Option + E, release then type Shift + E",
    winLc: "Alt + 0233 or 130",
    winUc: "Alt + 0201 or 144"
  },
  {
    charLc: "\xEC",
    charUc: "\xCC",
    macLc: "Option + `, release then type I",
    macUc: "Option + `, release then type Shift + I",
    winLc: "Alt + 0236 or 141",
    winUc: "Alt + 0204"
  },
  {
    charLc: "\xF2",
    charUc: "\xD2",
    macLc: "Option + `, release then type O",
    macUc: "Option + `, release then type Shift + O",
    winLc: "Alt + 0242",
    winUc: "Alt + 0210"
  },
  {
    charLc: "\xF9",
    charUc: "\xD9",
    macLc: "Option + `, release then type U",
    macUc: "Option + `, release then type Shift + U",
    winLc: "Alt + 0249 or 151",
    winUc: "Alt + 0217"
  },
  {
    charLc: "\xAB",
    charUc: "\xAB",
    macLc: "Option + \\",
    macUc: "",
    winLc: "Alt + 0171 or 174",
    winUc: ""
  },
  {
    charLc: "\xBB",
    charUc: "\xBB",
    macLc: "Shift + Option + \\",
    macUc: "",
    winLc: "Alt + 0187 or 175",
    winUc: ""
  },
  {
    charLc: "\u20AC",
    charUc: "\u20AC",
    macLc: "Shift + Option + 2",
    macUc: "",
    winLc: "Alt + 0128",
    winUc: ""
  }
];

const wiris_toolbar = {
  basic: `
      <toolbar name="basic-math" removeLinks="true">
        <tab name="basic-math-tab" rows="1">
          <section>
            <item ref="+" />
            <item ref="-" />
            <item ref="&#215;" />
            <item ref="&#247;" />
          </section>
          <section>
            <item ref="fraction" />
            <item ref="superscript" />
            <item ref="squareRoot" />
            <item ref="nRoot" />
          </section>
          <section>
            <item ref="=" />
            <item ref="&#8800;" />
            <item ref="&lt;" />
            <item ref=">" />
            <item ref="&#8804;" />
            <item ref="&#8805;" />
          </section>
          <section>
            <item ref="parenthesis" />
          </section>
          <section>
            <item ref="&#960;" />
          </section>
        </tab>
      </toolbar>
    `.trim(),
  full: `
      <toolbar ref="general" removeLinks="true" />
    `.trim(),
  mathk3: `
      <toolbar name="basic-math" removeLinks="true">
        <tab name="basic-math-tab" rows="1">
          <section>
            <item ref="+" />
            <item ref="-" />
            <item ref="&#215;" />
            <item ref="&#247;" />
          </section>
          <section>
            <item ref="=" />
            <item ref="&lt;" />
            <item ref=">" />
          </section>
          <section>
            <item ref="questionMark" />
          </section>
        </tab>
      </toolbar>
    `.trim(),
  math45: `
      <toolbar name="basic-math" removeLinks="true">
        <tab name="basic-math-tab" rows="1">
          <section>
            <item ref="+" />
            <item ref="-" />
            <item ref="&#215;" />
            <item ref="&#247;" />
          </section>
          <section>
            <item ref="fraction" />
            <item ref="superscript" />
          </section>
          <section>
            <item ref="=" />
            <item ref="&lt;" />
            <item ref=">" />
          </section>
        </tab>
      </toolbar>
    `.trim(),
  math68: `
      <toolbar name="basic-math" removeLinks="true">
        <tab name="basic-math-tab" rows="1">
          <section>
            <item ref="+" />
            <item ref="-" />
            <item ref="&#215;" />
            <item ref="&#247;" />
          </section>
          <section>
            <item ref="fraction" />
            <item ref="superscript" />
            <item ref="squareRoot" />
          </section>
          <section>
            <item ref="=" />
            <item ref="&lt;" />
            <item ref=">" />
            <item ref="&#8804;" />
            <item ref="&#8805;" />
          </section>
          <section>
            <item ref="parenthesis" />
          </section>
          <section>
            <item ref="&#960;" />
          </section>
        </tab>
      </toolbar>
    `.trim(),
  geometry: `
    <toolbar name="basic-math" removeLinks="true">
      <tab name="basic-math-tab" rows="1">
        <section>
          <item ref="+" />
          <item ref="-" />
          <item ref="&#215;" />
          <item ref="&#247;" />
        </section>
        <section>
          <item ref="fraction" />
          <item ref="superscript" />
          <item ref="squareRoot" />
        </section>
        <section>
          <item ref="=" />
          <item ref="&lt;" />
          <item ref=">" />
          <item ref="&#8804;" />
          <item ref="&#8805;" />
        </section>
        <section>
          <item ref="parenthesis" />
        </section>
        <section>
          <item ref="&#960;" />
        </section>
      </tab>
    </toolbar>
  `.trim(),
  default: `
      <toolbar ref="quizzes" removeLinks="true" />
    `.trim()
};

exports.french = french;
exports.german = german;
exports.italian = italian;
exports.spanish = spanish;
exports.wiris_toolbar = wiris_toolbar;
